import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IAdminPointRuleUpdate } from 'api'
import { useNavigate } from 'react-router-dom'

export default function PointEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')

  const { data, refetch } = useApi({
    id: 'pointRuleDetail',
    fn: api().adminPointRule.adminPointRuleDetail,
    params: Number(id),
    enabled: !!id,
  })

  const onSave = async (saveData: IAdminPointRuleUpdate) => {
    if (id) {
      await api().adminPointRule.adminPointRuleUpdate(Number(id), saveData)
      navigate('/point', { replace: true })
    }
    refetch()
  }

  const onDelete = async () => {
    if (id) {
      await api().adminPointRule.adminPointRuleDelete(Number(id))
      navigate('/point', { replace: true })
    }
  }

  return (
    <ContentDetailView
      title="포인트 룰 수정"
      data={data}
      onSave={onSave}
      onDelete={onDelete}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: '적립 유형',
            key: 'referenceType',
            type: FormFieldType.SELECT,
            options: [
              {
                label: '회원가입',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.SIGNUP,
              },
              {
                label: '프로필 작성',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.WRITE_PROFILE,
              },
              {
                label: '주문',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.ORDER,
              },
              {
                label: '이벤트',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.EVENT,
              },
              {
                label: '추천',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.REFERRAL,
              },
              {
                label: '리뷰 작성',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.REVIEW,
              },
              {
                label: '댓글 작성',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.COMMENT,
              },
              {
                label: '일일 출석',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.DAILY,
              },
              {
                label: '포인트 만료',
                value: IAdminPointRuleRoO1ReferenceTypeEnum.EXPIRE,
              },
            ],
            required: true,
            readOnly: true,
          },
          {
            label: '포인트 룰명',
            key: 'name',
            type: FormFieldType.STRING,
            required: true,
          },
          {
            label: '적립 포인트',
            key: 'amount',
            type: FormFieldType.NUMBER,
            required: true,
          },
        ]}
      />
    </ContentDetailView>
  )
}
